import { useResponsive } from "@design-lab/shared/hooks/useResponsive";
import { AiHeader } from "./AiHeader";
import { AiImageGallery, type GeneratedImage } from "./AiImageGallery";
import { PromptForm } from "./PromptForm";
import { PromptFormMobile } from "./PromptFormMobile";

export type AiGalleryViewProps = {
  prompt: string;
  images: GeneratedImage[];
  isGenerating: boolean;
  selectedImageId: number | undefined;
  uploadingImageId: number | undefined;
  error: string | undefined;
  startTime: number | undefined;
  hasGeneratedImages: boolean;
  onPromptChange: (prompt: string) => void;
  onGenerate: (prompt: string) => void;
  onImageSelect: (imageId: number) => void;
  onImageEdit?: (imageId: number) => void;
};

export function AiGalleryView({
  prompt,
  images,
  isGenerating,
  selectedImageId,
  uploadingImageId,
  error,
  startTime,
  hasGeneratedImages,
  onPromptChange,
  onGenerate,
  onImageSelect,
  onImageEdit
}: AiGalleryViewProps) {
  const { isDesktop } = useResponsive();

  if (isDesktop) {
    return (
      <div className="flex h-full gap-6">
        {/* Left Side - AI Design Form */}
        <div className="flex w-1/2 flex-col">
          <AiHeader />
          <PromptForm
            prompt={prompt}
            onPromptChange={onPromptChange}
            onGenerate={onGenerate}
            isLoading={isGenerating}
            error={error}
            hasGeneratedImages={hasGeneratedImages}
          />
        </div>

        {/* Right Side - AI Image Gallery */}
        <div className="w-1/2">
          <AiImageGallery
            images={images}
            isGenerating={isGenerating}
            selectedImageId={selectedImageId}
            uploadingImageId={uploadingImageId}
            onImageSelect={onImageSelect}
            {...(hasGeneratedImages &&
              onImageEdit && {
                onImageEdit
              })}
            startTime={startTime}
          />
        </div>
      </div>
    );
  }

  // Mobile view
  return (
    <div className="flex h-full flex-col gap-3">
      <AiImageGallery
        images={images}
        isGenerating={isGenerating}
        selectedImageId={selectedImageId}
        uploadingImageId={uploadingImageId}
        onImageSelect={onImageSelect}
        {...(hasGeneratedImages &&
          onImageEdit && {
            onImageEdit
          })}
        startTime={startTime}
      />
      <PromptFormMobile
        prompt={prompt}
        onPromptChange={onPromptChange}
        onGenerate={onGenerate}
        isLoading={isGenerating}
        error={error}
        hasGeneratedImages={hasGeneratedImages}
      />
    </div>
  );
}
